import { render, staticRenderFns } from "./ProductPositionChoiceDialog.vue?vue&type=template&id=0462fe4e"
import script from "./ProductPositionChoiceDialog.vue?vue&type=script&lang=js"
export * from "./ProductPositionChoiceDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports